<template>
  <div class="list-container">
    <input id="copyUrlInput" type="text">
    <ul class="list-content" ref="list">
      <li @mouseenter="showTwoBtn(index)" @mouseleave="hideTwoBtn(index)" v-for="(item,index) in mListSave" :key="index" :style="'height:'+itemHeight+'px'" :class="{list: true,on: item.isSelected}">
        <div :style="'height:'+ itemImgHeight +'px'" class="cover">
          <div class='verify-success verify-item' v-if="item.has_audit&&item.has_audit==1&&+item.type === 2">
            <img class="verify-logo" src="@assets/img/common/verify-success-logo.svg">
            技审通过
          </div>

          <div class='verify-fail verify-item' v-if="item.has_audit&&item.has_audit==2&&+item.type === 2">
            <img class="verify-logo" src="@assets/img/common/verify-fail-logo.svg">
            技审未通过
          </div>
          <div @click="openDetail(item, index)" class="bg" v-if="item.type-0 === 1 || item.type-0 === 2" :style="{'background-image': `url(${item.cover || defaultImg})`}"></div>
          <div @click="openDetail(item, index)" class="bg" v-if="item.type-0 === 3" :style="{'background-image': `url(${item.cover || defaultMedia})`}"></div>
          <img @click="openDetail(item, index)" v-show="item.type-0 === 2 || item.type-0 === 3" class="playBtn" src="@assets/img/index/play.svg" alt="">
          <!-- <img v-show="item.is_new-0 === 1" class="newIcon" src="@assets/img/common/new-bold.svg" alt=""> -->
          <div v-if="item.isOn" @click="item.isSelected = !item.isSelected;setSelected(item)" :class="{selectIcon: true, show: true, on: item.isSelected}"></div>
          <div v-if="item.isOn" @click="item.showMenu = !item.showMenu;checkPos(index)" :class="{pointIcon: true, on: item.showMenu}"></div>
          <ul v-show="item.showMenu" class="pointList">
            <li>
              <span>创建</span>
              <i v-show="$store.state.create.material||$store.state.create.report||$store.state.create.publish"></i>
              <div :class="{left: item.showLeft}">
                <ul>
                  <li v-show="$store.state.create.material" @click="navigate('material',item.id)">
                    <span>上传线索</span>
                  </li>
                  <li v-show="$store.state.create.report" @click="navigate('report',item.id)">
                    <span>创建报道</span>
                  </li>
                  <li v-show="$store.state.create.publish" @click="navigate('publish',item.id)">
                    <span>创建发布</span>
                  </li>
                  <li v-show="$store.state.create.new_media" @click="navigate('new_media',item.id)">
                    <span>新媒体发布</span>
                  </li>
                </ul>
              </div>
            </li>
            <li v-if="(item.detail.has_low_quality_download_role || item.detail.has_high_quality_download_role || item.detail.has_publish_quality_download_role) && item.type != 1 && item.type != 3">
              <span>下载</span>
              <i></i>
              <div :class="{left: item.showLeft}">
                <ul>
                  <li @click="downloadSource(item,0)" v-if="item.detail.has_low_quality_download_role">
                    <span>800K码流下载</span>
                  </li>
                  <li @click="downloadSource(item,2)" v-if="item.detail.has_publish_quality_download_role">
                    <span>发布码流下载</span>
                  </li>
                  <li @click="downloadSource(item,1)" v-if="item.detail.has_high_quality_download_role">
                    <span>原始码流下载</span>
                  </li>
                </ul>
              </div>
            </li>
            <li @click="downloadSource(item,1)" v-if="(item.detail.has_low_quality_download_role || item.detail.has_high_quality_download_role) && item.type == 1">
              <span>下载</span>
            </li>
            <li @click="downloadSource(item,1)" v-if="(item.detail.has_low_quality_download_role || item.detail.has_high_quality_download_role) && item.type == 3">
              <span>下载</span>
            </li>
            <li v-if="(item.detail.has_low_quality_copy_role || item.detail.has_high_quality_copy_role) && item.type != 1 && item.type != 3">
              <span>复制</span>
              <i></i>
              <div :class="{left: item.showLeft}">
                <ul>
                  <li @click="copySource(item,0)" :class="{un: !item.detail.low_quality_copy_available}" v-if="item.detail.has_low_quality_copy_role">
                    <span>800K码流复制</span>
                  </li>
                  <li @click="copySource(item,1)" v-if="item.detail.has_high_quality_copy_role">
                    <span>原始码流复制</span>
                  </li>
                </ul>
              </div>
            </li>
            <li @click="copySource(item,1)" v-if="(item.detail.has_low_quality_copy_role || item.detail.has_high_quality_copy_role) && item.type == 1">
              <span>复制</span>
            </li>
            <li @click="copySource(item,1)" v-if="(item.detail.has_low_quality_copy_role || item.detail.has_high_quality_copy_role) && item.type == 3">
              <span>复制</span>
            </li>
            <li v-if="item.type == 2 && $store.state.quickEdit && item.detail.edit_role" @click="edit(item,item.type)">
              <span>编辑</span>
            </li>
            <li v-if="item.type != 2 && item.detail.edit_role" @click="edit(item,item.type)">
              <span>编辑</span>
            </li>
            <li v-if="$store.state.quickEdit" @click="useDetail(item.id)">
              <span>选用</span>
            </li>
            <li v-if="item.has_stream_send" @click="mediaSend(item.id)">
              <span>归档</span>
            </li>
            <li v-if="item.has_share" @click="$ShareCode(item.id)">
              <span>分享</span>
            </li>
          </ul>
          <!-- <div class="mask">
            <div @click="openDetail(item, index)" class="whiteBg">
              <i></i>
            </div>
          </div> -->
        </div>
        <div :class="{detail: true, on: item.isOn}">
          <p @click="openDetail(item, index)" class="title">
            <img v-show="item.type-0 === 1" src="@assets/img/common/imgIcon.svg" alt="img">
            <img v-show="item.type-0 === 3" src="@assets/img/common/audioIcon.svg" alt="img">
            <img v-show="item.type-0 === 2" src="@assets/img/common/videoIcon.svg" alt="img">
            <span v-html="item.title"></span>
          </p>
          <div class="detail bold">
            <p title="发布时间" class="clock">
              <img src="@assets/img/material/clockIcon.svg" alt="">
              <span>{{item.raw_add_time}}</span>
            </p>
            <p title="被采用情况" class="share">
              <img src="@assets/img/material/shareIcon.svg" alt="">
              <span>被引用 {{item.use_num}}</span>
              <span v-if="item.use_list && item.use_list.length > 0" class="tips">
                <p class="tip" @click.stop="goRptDtl(el)" v-for="(el,key) in item.use_list" :key="key">
                  <img v-if="el.use_type == 'report'" src="@assets/img/common/reportIcon.svg">
                  <img v-if="el.use_type == 'publish'" src="@assets/img/common/uploadIcon.svg">
                  <img v-if="el.use_type == 'new_media'" src="@assets/img/common/uploadIcon.svg">
                  <img style="margin-left: 1.5px;margin-right: 11.5px;" v-if="el.use_type == 'material'" src="@assets/img/common/materialIcon.svg">
                  <i :title="el.title" class="tiptitle">{{el.title}}</i>
                  <i class="tiper">{{el.username}}</i>
                  <i class="tiptime">{{el.raw_update_time}}</i>
                </p>
              </span>
            </p>
            <p title="信源" class="source">
              <img src="@assets/img/material/sourceIcon.svg" alt="">
              <span>{{item.source_info && item.source_info.ptitle}}</span>
            </p>
          </div>
        </div>
      </li>
      <li class="fillItem" :style="{height: 0, width: `${fillWidth}px`}"></li>
    </ul>
  </div>
</template>

<script>
import common from "@common/common";
import { apis } from "@common/config";
import store from "@common/store";

export default {
  props: {
    mList: {
      type: Array
    }
  },
  data() {
    return {
      selectList: [],
      mListSave: [],
      defaultImg: require("@assets/img/common/default.png"),
      defaultMedia: require("@assets/img/common/audioMask.jpg"),
      fillWidth: 0,
      itemHeight: 100,
      itemImgHeight: 100,
      isXnew: this.$store.state.isXnew,
    };
  },
  watch: {
    "$store.state.isSelectAll": function (e) {
      if(e){
        this.selectList = [];
        this.mListSave.forEach(el => {
          this.selectList.push(el)
          this.$set(el, 'isOn', true)
          this.$set(el, 'isSelected', true)
        })
        store.commit("setSelectList", this.selectList);
      }else{
        this.selectList = [];
        this.mListSave.forEach(el => {
          this.$set(el, 'isOn', false)
          this.$set(el, 'isSelected', false)
        })
        store.commit("setSelectList", this.selectList);
      }
    },
    "$store.state.cancelSelect": function (e) {
      this.selectList = [];
      this.mListSave.forEach(el => {
        this.$set(el, 'isOn', false)
        this.$set(el, 'isSelected', false)
      })
      store.commit("setSelectList", this.selectList);
    }
  },
  methods: {
    mediaSend(id) {
      let info = {
          subject_type: 10,
          subject_id: id
      };
      common
      .myFetch(apis.streamMediaSend, info)
      .then(r => {
          if (r) {
              this.$toast(r)
          }
      });
    },
    copySource(source, type) {
      console.log(source)
      if(type === 0){
        if(!source.detail.low_quality_copy_available){
          this.$toast("转码中暂无法复制链接");
          return;
        }
      }
      // return false;
      let data = {
        id: source.id,
        type: type
      };

      common.myFetch(apis.materialCopy, data).then(res => {
        console.log(res)
        let dom = document.getElementById('copyUrlInput')
        dom.value = res.copy_url;
        dom.select()
        document.execCommand("Copy");
        this.$toast("复制成功");
      });
    },
    setSelected(item) {
      if(item.isSelected){
        this.selectList.push(item)
      }else{
        this.selectList = this.selectList.filter(el => {
          return el.id != item.id
        })
      }
      let length = this.mListSave.length;
      console.log(this.selectList,length)
      if(this.selectList.length != length){
        this.$emit('setIsSelectAll', false)
        // store.commit("setIsSelectAll", false);
      }else{
        this.$emit('setIsSelectAll', true)
        // store.commit("setIsSelectAll", true);
      }
      store.commit("setSelectList", this.selectList);
    },
    useDetail(id) {
      let data = {
        file_ids: id
      };

      common.myFetch(apis.File_addquickfile, data).then(res => {
        if (res) {
          this.$toast("已成功加入选用素材");
          store.commit("setQuickEditNum", res.quick_edit_num);
        }
      });
    },
    edit(detail,type) {
      if (type - 0 === 1) {
        this.editPic(detail);
      } else if (type - 0 === 2) {
        let info = {
          title: detail.title,
          id: String(detail.id)
        }
        this.$cloudEditConfirm(info).then((res) => {
          if(res != 999){
            window.open(res.meisheurl)
          }
        })
        // console.log(this.detail)
      } else if (type - 0 === 3) {
        this.editVideo(detail.detail.text_status, detail);
      }
    },
    editVideo(i, j) {
      console.log(i, j);
      let newObj = {
        pageType: null,
        pageId: null,
        file_format: j.detail.upload.url,
        appId: j.detail.upload.app_id,
        appSecret: j.detail.upload.app_secret
      };
      Object.assign(j, newObj);
      this.$voiceEditType(i, j).then(res => {
        console.log(res, i);
        if (res == 0 && i == 3 && res !== false) {
          // console.log(this.pageType,this.$route.query.d,j)
          const newWindow = window.open();
          // console.log(`${window.location.origin}/voiceEdit/${this.pageType}/${this.$route.query.d}/${j.idstring}`)
          newWindow.location.href = `${window.location.origin
            }/voiceEdit/${this.pageType}/${this.pageId}/${j.detail.idstring
            }`;
        } else if (res == "peComplete") {
          this.test();
        }
      });
    },
    test() {

    },
    editPic(i) {
      i.t = null;
      i.d = i.id;
      i.url = i.detail.url;
      this.$picEditType1(i, this.test).then(el => {
        if (Number(el) == '123') {
          store.commit('setflashPic1', true)
        }
      });
    },
    async navigate(type, id) {
      if (type === "material") {
        let info = {
          id: id,
          push_to: type,
          type: 0
        };
        common.myFetch(apis.File_filepush, info).then(r => {
          if (r) {
            common.jump(`/creatClue?t=0&d=${r.id}`, true);
          }
        });
      } else if (type === "report") {
        const typeName = await this.$pageType();
        if (!typeName) return;
        let info = {
          id: id,
          push_to: type,
          type: typeName
        };
        common.myFetch(apis.File_filepush, info).then(r => {
          if (r) {
            common.jump(`/creatReport?t=${typeName}&d=${r.id}`, true);
          }
        });
      } else if (type === "publish") {
        const typeName = await this.$pageType("publish");
        if (!typeName) return;
        let info = {
          id: id,
          push_to: type,
          type: typeName
        };
        common.myFetch(apis.File_filepush, info).then(r => {
          if (r) {
            common.jump(`/createPublish?t=${typeName}&d=${r.id}`, true);
          }
        });
      } else if (type === "new_media") {
        const typeName = await this.$MediaPlatform();
        if (!typeName) return;
        let info = {
          file_ids: id,
          subject_type: 5,
          subject_id: typeName
        };
        common.myFetch(apis.File_bind, info).then(r => {
          if (r) {
            common.jump(`/createMediaPublish?d=${typeName}`, true);
          }
        });
      }
    },
    downloadSource(source, type) {
      if (type === 0) {
        if (!source.detail.has_low_quality_download_role) {
          this.$toast("无下载权限");
          return;
        } else {
          if (source.type != 1) {
            if (source.content.status != 1) {
              this.$toast("转码尚未完成");
              return;
            }
          }
        }
      } else if (type === 1) {
        if(source.type == 1){
          if (!source.detail.has_high_quality_download_role&&!source.detail.has_low_quality_download_role) {
            this.$toast("无下载权限");
            return;
          }
        }else if(source.type == 3) {
          if (!source.detail.has_high_quality_download_role&&!source.detail.has_low_quality_download_role) {
            this.$toast("无下载权限");
            return;
          }
        }else{
          if (!source.detail.has_high_quality_download_role) {
            this.$toast("无下载权限");
            return;
          }
        }
      }

      const info = {
        idstring: source.detail.idstring,
        file_quality: type || 0
        // subject_type: 0,
        // subject_id: this.$route.query.d
      };
      const url = apis.File_download;
      const userKeys = common.userKeys();
      const params = Object.assign({}, info, userKeys);

      common.exportRes(url, params, 1);
    },
    checkPos(e) {
      let offsetLeft = document.documentElement.clientWidth - document.querySelectorAll('.list-content > li')[e].offsetLeft
      if(offsetLeft < 600){
        this.$set(this.mListSave[e], 'showLeft', true)
      }
    },
    showTwoBtn(index) {
      this.$set(this.mListSave[index], 'isOn', true)  
    },
    hideTwoBtn(index) {
      if(!this.mListSave[index].isSelected){
        this.$set(this.mListSave[index], 'isOn', false)
      }  
      this.$set(this.mListSave[index], 'showMenu', false)
      this.$set(this.mListSave[index], 'showLeft', false)
    },
    openDetail(detail, index) {
      if (!detail.trans_finish) {
        this.$toast("转码中，暂时无法预览");
        return;
      }
      this.mListSave[index].is_new = false;
      let data = {
        type: detail.type,
        id: detail.id,
        create: this.$store.state.create,
        canEdit: false,
        quickEdit: this.$store.state.quickEdit
      };
      this.$materialBox(data);
    },
    // 被采用
    goRptDtl({ use_type, id }) {
      if (use_type == "report") {
        common.jump(`/reportDetail?d=${id}`, true);
      } else if (use_type == "publish") {
        common.jump(`/publishDetail?d=${id}`, true);
      } else if (use_type == "material") {
        common.jump(`/clueDetail?d=${id}`, true);
      } else if (use_type == "new_media") {
        common.jump(`/mediaPublishDetail?d=${id}`, true);
      }
    },
    calcFillWidth() {
      // console.log(999)
      // 计算填充元素宽度
      const list = this.$refs.list;
      if (!list || !list.getBoundingClientRect()) return;
      const listWidth = list.getBoundingClientRect().width;
      let fillWidth = 0;
      const itemWidth = 255; // item dom宽度
      const itemGap = 12; //item 边距
      const listGap = 12; // list左右边距
      const countsPerPage = this.mListSave.length || 20; //每页的item数量
      const containerWidth = listWidth - listGap; //容器实际宽度（dom宽度 - 左右padding）
      const countsPerRow = parseInt(containerWidth / (itemWidth + itemGap)); //每行item数量
      const countsLastLine = countsPerPage % countsPerRow || countsPerRow; //最后一行的item数量
      const itemRatio = 284.5 / 255;
      const itemWidthNow = (listWidth - listGap) / countsPerRow - itemGap;
      const itemHeightNow = itemWidthNow * itemRatio;

      fillWidth =
        countsPerRow === countsLastLine
          ? 0
          : (countsPerRow - countsLastLine) * (itemWidthNow + itemGap);

      this.fillWidth = fillWidth;
      // console.log(listWidth,countsPerRow,listWidth/countsPerRow,((itemWidthNow)*9/16))
      this.itemHeight = (((listWidth/countsPerRow)-14)*9/16)+135;
      this.itemImgHeight = (((listWidth/countsPerRow)-14)*9/16);
      // console.log(this.itemHeight)
      // console.log('list', itemWidthNow, itemHeightNow, countsPerRow, fillWidth)
    },
    addCalcEvent() {
      // 监听list dom宽度变化
      window.addEventListener("resize", () => {
        this.calcFillWidth();
      });
    }
  },
  mounted() {
    // this.mList.forEach(el => {
    //   el.isSelected = false;
    //   el.isOn = false;
    // })
    this.mListSave = this.mList;
    this.defaultImg = this.$_syscfg.default_img
    this.defaultMedia = this.$_syscfg.default_media
    this.addCalcEvent();
    this.calcFillWidth();
  }
};
</script>

<style lang="less" src="@assets/css/index/index.less" scoped>
</style>

<style lang="less">
.list-container {
  em {
    color: #41B48C;
    font-style: normal;
  }
}
</style>
